import React from "react";
import { useModalSubscriptionAssignHook } from "./modal-subscription-assign-hooks";

type ContextModalSubscriptionAssign = ReturnType<
  typeof useModalSubscriptionAssignHook
>;
export const ModalSubscriptionAssignContext =
  React.createContext<ContextModalSubscriptionAssign | null>(null);

export function useContextModalSubscriptionAssign() {
  const context = React.useContext(ModalSubscriptionAssignContext);

  if (!context) {
    throw new Error(
      "useContextModalSubscriptionAssign must be used within a ContextModalSubscriptionAssignProvider",
    );
  }

  return context;
}
